import { Flex } from "antd";
import React from "react";
import { Loading } from "@100mslive/roomkit-react";
import ButtonComponent from "@/components/button/Button";
import { updateRoomStatusById } from "@/services/users/updateRoomStatus";
import { useNavigate, useParams } from "react-router-dom";
import useTriggerNotification from "@/hooks/useTriggerNotification";

const GuideLobby = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { trigger, element } = useTriggerNotification();

  const handleJoinCall = () => {
    updateRoomStatusById(id, {
      enable: true,
    })
      .then((res) => {
        if (res.code !== 403) {
          navigate(`/guide/meeting/${id}/${res.roomCode}`);
        } else {
          trigger({
            type: "error",
            message: res.message,
          });
        }
      })
      .catch((err) =>
        trigger({
          type: "error",
          message: err.response?.data?.msg,
        })
      );
  };

  return (
    <>
      {element}
      <Flex
        justify="center"
        align="center"
        style={{ height: "300px", paddingBottom: "10px" }}
        vertical
        gap={"40px"}
      >
        <Loading size={100} color="#db5800" />
        <Flex vertical gap={"10px"}>
          <div className="body-b3">Almost there! The student is on their way</div>
          <Flex
            className="add-note"
            style={{
              background: "white",
              marginTop: "1rem",
              padding: "1rem",
              borderRadius: "8px",
              border: "1px solid #E5E5E5",
            }}
          >
            <p>
              <span className="body-b3" style={{ fontWeight: 500 }}>
                Note:
              </span>{" "}
              <span className="body-b3">
                This session will be recorded and the recording will be provided to you via the
                dashboard after the session is over
              </span>
            </p>
          </Flex>
          <ButtonComponent label="Start Call" onClick={handleJoinCall} />
        </Flex>
      </Flex>
    </>
  );
};

export default GuideLobby;
